import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { useButtonHoverColorProp } from '../../theme/tokens/button-color';
import { useCFButtonHoverColorProp } from '../../theme/tokens/contentful-color';

import { Button } from '../Button';
import { Flexbox } from '../Flexbox';

export const OptionContainer = styled(Flexbox)`
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  padding: ${({ theme }) => theme.spacing.blockPadding};
  border: 1px solid ${({ theme }) => theme.color.inputBorder};
  height: ${pxToRem(236)};
  width: 100%;

  ${mediaQueries.desktop} {
    height: ${pxToRem(264)};
  }
`;

export const Details = styled('div')`
  flex: 1;
`;

export const SubscriptionButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(64)};
  font-size: ${({ theme }) => theme.fontSize.m};
  line-height: ${pxToRem(16)};
  color: ${({ theme }) => theme.color.black} !important;
  background-color: ${({ theme }) => theme.color.giftingSubscriptionButton};

  &:active {
    ${useButtonHoverColorProp};
    ${useCFButtonHoverColorProp};
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(64)};
  }
`;
